import VerticalCard from "./VerticalCard";

export default VerticalCard;
